export enum AssessmentCustomStatusValue {
  VIEWED = '100_VIEWED',
  NOT_VIEWED = '001_NOT_VIEWED',
  COMPLETED = '003_COMPLETED',
}
